import React from 'react';
import config from '../../../../config/index';

import style from './LoginFooter.module.scss';

const LoginFooter = () => (
  <div>
    <ul className={style.footerMenu}>
      <li className={style.footerMenuItem}><a className={style.footerMenuLink} href="https://my.chaserhq.com/">Chaser App</a></li>
      <li className={style.footerMenuItem}><a className={style.footerMenuLink} href={config.helpCentre} target="_blank" rel="noopener noreferrer">Help Centre</a></li>
      <li className={style.footerMenuItem}><a className={style.footerMenuLink} href="mailto:support@chaserhq.com">Support</a></li>
    </ul>
  </div>
);

export default LoginFooter;
